export default __webpack_public_path__ + "static/media/MNRC.253ce120.webp";